<div class="table-wrapper card" #tableWrapper>
    <div class="table-container" *ngIf="!DataLoading">
        <table class="row-border hover table table-bordered com_table" style="width: 100%;" id="resizableTable">
            <thead>
                <!-- <tr class="text-dark" style="border-left: 5px solid #F24800;"> -->
                <tr class="text-dark">
                    <th scope="col" *ngIf="EnableMultiSelect"
                        style="border-left: 5px solid var(--bs-primary);width:30px; min-width:30px; max-width:30px;">
                        <input type="checkbox" *ngIf="tableData && tableData.length > 0;" [(ngModel)]="masterSelected"
                            (change)="toggleSelectAll()" />
                    </th>

                    <th *ngIf="enableActionColumn" scope="col" style="width:30px; min-width:30px; max-width:30px;"
                        class="text-center">
                        <i class="bi bi-gear-fill"></i>
                    </th>

                    <th scope="col" *ngIf="enableAutoSerial" style="width:50px; min-width:50px; max-width:50px;"
                        class="text-center">
                        SrNo
                    </th>

                    <th scope="col" *ngFor="let col of visibleColumns; let i = index"
                        (click)="columnSortClick(col.sortBy!)" [style.width.px]="col.colWidth" class="resizable-column"
                        [ngClass]="{
      'sortable': col.sortBy && col.sortBy.trim(),
      'sorted-column': currentSortColumn === col.sortBy && currentSortDirection,
      'th-has-filter': shouldShowFilterIcon(col),
      'th-has-config': i === firstConfigurableColumnIndex
    }">

                        <!-- TEXT + SORT (exactly like old version) -->
                        <span class="column-name-text" [ngbTooltip]="col.colName">
                            {{col.colName}}
                        </span>

                        <i *ngIf="col.sortBy && col.sortBy.trim()" [ngClass]="getSortIcon(col.sortBy)"
                            class="sort-icon">
                        </i>

                        <!-- 🔍 FILTER ICON -->
                        <i *ngIf="shouldShowFilterIcon(col)" 
                            class="bi bi-funnel filter-icon"
                            [ngClass]="{'filter-active': isFilterActive(col.colData)}"
                            (click)="openFilterPopup($event, col)"
                            [ngbTooltip]="isFilterActive(col.colData) ? 'Remove filter' : 'Add filter'">
                        </i>

                        <!-- ⚙ SETTINGS ICON -->
                        <i *ngIf="col.colData === visibleColumns[firstConfigurableColumnIndex]?.colData"
                            class="fa-solid fa-sliders column-config-icon" (click)="toggleColumnConfig($event)"
                            [ngbTooltip]="'Column settings'">
                        </i>

                        <div class="resizer" (mousedown)="startResize($event, col)">
                        </div>

                    </th>


                    <th *ngIf="enableCheckboxColumn">{{ checkboxColumnLabel }}</th>
                    <!-- <th *ngIf="enableActionColumn" class="text-center">{{ actionColumnLabel }}</th> -->
                </tr>
            </thead>

            <tbody id="TemplateListBody">
                <ng-container *ngIf="tableData && tableData.length > 0; else noData">

                    <!-- <tr *ngFor="let rows of tableData; let i = index" [style.border-left]="'5px solid #' + WCColors[i % WCColors.length]"> -->
                    <tr *ngFor="let rows of tableData; let i = index" [attr.data-row-object]="encodeRowData(rows)"
                        [ngStyle]="toggleStatus && rows.isActive === 0 ? {'background-color': 'var(--ui-surface-subtle)'} : {}"
                        [ngClass]="toggleStatus && rows.isActive === 0 ? 'disable-hover':''">
                        <td *ngIf="EnableMultiSelect">
                            <input type="checkbox" [checked]="rows.isSelected"
                                (change)="onSelctionCheckboxChange($event,rows)">
                        </td>
                        <td class="text-center" *ngIf="enableActionColumn"
                            style="width:40px; min-width:40px; max-width:40px; overflow: visible;">

                            <div class="btn-group dots_dropdown">
                                <button type="button" class="dropdown-toggle" data-bs-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false"
                                    (click)="positionDropdown($event)">
                                    <i class="bi bi-three-dots-vertical"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right shadow-lg">

                                    <ng-container *ngFor="let option of actionOptions">
                                        <ng-container *ngIf="option.customDivClass">
                                            <div class="uic-action-custom-slot"
                                                [ngClass]="option.customDivClass"></div>
                                        </ng-container>
                                    </ng-container>

                                    <ng-container *ngFor="let option of actionOptions">

                                        <ng-container
                                            *ngIf="!option.customDivClass && checkActionOptionCondition(option, rows)">
                                            <button class="dropdown-item" type="button"
                                                (click)="actionButtonClick(option.actionName,rows)">
                                                <i [ngClass]="option.actionIcon"></i>&nbsp;{{option.actionName}}
                                            </button>
                                        </ng-container>

                                        <ng-container *ngIf="!option.customDivClass && toggleStatus && option.action">

                                            <ng-container
                                                *ngIf="rows.isActive === 0 && rows.isDeleted === 0 && option.action == 'enable'">
                                                <button class="dropdown-item" type="button"
                                                    (click)="actionButtonClick(option.actionName,rows)">
                                                    <i [ngClass]="option.actionIcon"></i>&nbsp;{{option.actionName}}
                                                </button>
                                            </ng-container>

                                            <ng-container
                                                *ngIf="rows.isActive === 1 && rows.isDeleted === 0 && option.action == 'disable'">
                                                <button class="dropdown-item" type="button"
                                                    (click)="actionButtonClick(option.actionName,rows)">
                                                    <i [ngClass]="option.actionIcon"></i>&nbsp;{{option.actionName}}
                                                </button>
                                            </ng-container>



                                        </ng-container>

                                    </ng-container>




                                </div>
                            </div>
                        </td>

                        <td *ngIf="enableAutoSerial" style="width:50px; min-width:50px; max-width:50px;"
                            class="text-center">{{i+1}}</td>

                        <!-- <td *ngFor="let col of visibleColumns" [style]="col.colStyle"> -->
                        <td *ngFor="let col of visibleColumns" [style.width.px]="col.colWidth" [style]="col.colStyle">
                            <!-- Button Column -->
                            <ng-container *ngIf="col.isButton; else normalColumn">
                                <i [ngClass]="col.buttonIcon" (click)="onButtonClick(col.buttonAction!, rows)"
                                    style="cursor: pointer;"></i>
                            </ng-container>

                            <!-- Normal Column with Badge or Regular Content -->
                            <ng-template #normalColumn>
                                <div [ngClass]="col.isBadge ? 'badge badge-secondary font-l' : (enableBadge===col.colName? 'badge badge-secondary font-l':'')"
                                    [ngbTooltip]="(col.isBadge || col.isHtml) ? null : getLowerCaseValue(rows,col.colData)"
                                    [style.background-color]="col.isBadge && col.badgeColor ? col.badgeColor : (enableBadge===col.colName? '#' + WCColors[i % WCColors.length]:'')"
                                    class="colDiv" style="width: 90% !important;"
                                    [class]="col.colClass? col.colClass : ''">

                                    <ng-container *ngIf="col.enableRouting else checkHtml">
                                        <a [routerLink]="[col.routing!.route,rows[col.routing!.id]]"
                                            [queryParams]="col.routing?.queryParams">{{ col.isDate ?
                                            (getLowerCaseValue(rows,col.colData) | date:'dd/MM/yyyy') :
                                            getLowerCaseValue(rows,col.colData) }}</a>
                                    </ng-container>
                                    <ng-template #checkHtml>
                                        <ng-container *ngIf="col.isHtml; else normalData">
                                            <span
                                                [innerHTML]="getTrustedHtml(getLowerCaseValue(rows,col.colData))"></span>
                                        </ng-container>
                                    </ng-template>
                                    <!-- <ng-template #normalData>
                                        {{ col.isDate ? (getLowerCaseValue(rows,col.colData) | date:'dd/MM/yyyy') :
                                        getLowerCaseValue(rows,col.colData) }}
                                    </ng-template> -->
                                    <ng-template #normalData>

                                        <!-- EDIT MODE -->
                                        <ng-container *ngIf="enableInlineEditing && rows._editingColumn === col.colData && col.otherDetails === 'editable'">

                                            <div class="d-flex align-items-center gap-2">

                                                <input type="text" class="form-control form-control-sm"
                                                    [(ngModel)]="rows[col.colData]" value=rows[col.colData]/>

                                                <!-- OK button -->
                                                <i class="bi bi-check-lg text-success" role="button"
                                                    (click)="onInlineEditSave(rows, col)"></i>

                                                <!-- Cancel button -->
                                                <i class="bi bi-x-lg text-danger" role="button"
                                                    (click)="onInlineEditCancel(rows, col)">
                                                </i>

                                            </div>

                                        </ng-container>

                                        <!-- NORMAL MODE -->
                                        <span
                                            *ngIf="!(enableInlineEditing && rows._editingColumn === col.colData && col.otherDetails === 'editable')">

                                            {{ col.isDate
                                            ? (getLowerCaseValue(rows,col.colData) | date:'dd/MM/yyyy')
                                            : getLowerCaseValue(rows,col.colData) }}

                                        </span>

                                    </ng-template>
                                    <span
                                        *ngIf="enableInlineEditing && col.otherDetails === 'editable' && !hideEditButton"
                                        class="ms-2">

                                        <i class="bi bi-pencil-square" style="cursor:pointer"
                                            (click)="onInlineEditClick(rows, col)">
                                        </i>

                                    </span>
                                </div>
                            </ng-template>

                        </td>
                        <td *ngIf="enableCheckboxColumn" class="text-center">
                            <input type="checkbox" [(ngModel)]="rows[checkboxStateBinding]"
                                (change)="onCheckboxChange(rows)" [checked]="rows[checkboxStateBinding]===1" />
                        </td>



                    </tr>

                </ng-container>


                <ng-template #noData>
                    <tr>
                        <td colspan="7">
                            <span class="text-muted">No Records found..</span>
                        </td>
                    </tr>
                </ng-template>


            </tbody>
        </table>

        <div class="column-config-popover" *ngIf="showColumnConfig" [ngStyle]="columnConfigPosition"
            (click)="$event.stopPropagation()">

            <div class="config-header">
                Column Settings
            </div>

            <div class="config-body">
                <div *ngFor="let col of configColumnOrder; let i = index" 
                    class="config-item"
                    draggable="true"
                    (dragstart)="onDragStart($event, i)"
                    (dragover)="onDragOver($event, i)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event, i)"
                    (dragend)="onDragEnd()"
                    [ngClass]="{'dragging': draggedColumnIndex === i, 'drag-over': dragOverIndex === i}"
                    style="cursor: move; padding: 4px 8px; margin: 2px 0; border-radius: 3px; transition: background-color 0.2s;"
                    [style.background-color]="dragOverIndex === i ? '#e3f2fd' : (draggedColumnIndex === i ? '#f5f5f5' : 'transparent')">
                    <input type="checkbox" [(ngModel)]="columnVisibilityState[col.colData]"
                        (change)="onColumnVisibilityChange()" [disabled]="!canToggleColumn(col)" />
                    <span style="user-select: none;">
                        <i class="bi bi-grip-vertical" style="margin-right: 8px; color: #999;"></i>
                        {{ col.colName }}
                    </span>
                </div>
            </div>

            <div class="config-error" *ngIf="columnVisibilityError">
                {{ columnVisibilityError }}
            </div>

            <div class="config-footer">
                <button class="btn btn-sm btn-secondary" (click)="cancelColumnVisibility()">
                    Cancel
                </button>
                <button class="btn btn-sm btn-primary" (click)="applyColumnVisibility()">
                    Save
                </button>
            </div>

        </div>

        <!-- ========== FILTER POPUPS ========== -->
        <ng-container *ngIf="openFilterPopupKey">
            <ng-container *ngFor="let col of visibleColumns">
                <ng-container *ngIf="col.colData === openFilterPopupKey">

                    <!-- ========== SELECT/DROPDOWN FILTER (API-backed) ========== -->
                    <!-- FilterInputType="select" + FilterDataFetchType="api" -->
                    <ng-container *ngIf="getFilterInputType(col) === 'select' && getFilterDataFetchType(col) === 'api'">
                        <div class="filter-popup-wrapper" [ngStyle]="filterPopupPosition" (click)="$event.stopPropagation()">
                            <div class="filter-popup-header">
                                <span>Filter by {{ col.colName }}</span>
                                <button class="btn btn-sm btn-close" (click)="closeFilterPopup()"></button>
                            </div>

                            <div class="filter-popup-body">
                                <!-- Search input (only for select&search) -->
                                <ng-container *ngIf="getFilterInputType(col) === 'selectNsearch'">
                                    <input type="text" class="form-control filter-search-input" 
                                        placeholder="Search..." 
                                        [(ngModel)]="filterSearchText[col.colData]"
                                        (keyup)="loadFilterOptions(col)"
                                        (keyup)="$event.stopPropagation()">
                                </ng-container>

                                <!-- Loading indicator -->
                                <div class="text-center p-2" *ngIf="filterLoadingKey === col.colData">
                                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span class="ms-2">Loading...</span>
                                </div>

                                <!-- Checkbox list -->
                                <div class="filter-options-list" *ngIf="filterLoadingKey !== col.colData">
                                    <!-- Select All Checkbox -->
                                    <div class="form-check filter-option-item filter-select-all" *ngIf="filterOptions[col.colData] && filterOptions[col.colData].length > 0">
                                        <input class="form-check-input" type="checkbox" 
                                            [checked]="isFilterSelectAllChecked(col.colData)"
                                            (change)="toggleFilterSelectAll(col.colData); $event.stopPropagation()"
                                            [id]="col.colData + '_selectall'">
                                        <label class="form-check-label" [for]="col.colData + '_selectall'">
                                            Select All
                                        </label>
                                    </div>

                                    <!-- Divider -->
                                    <div class="filter-select-all-divider" *ngIf="filterOptions[col.colData] && filterOptions[col.colData].length > 0"></div>

                                    <div class="form-check filter-option-item" 
                                        *ngFor="let option of filterOptions[col.colData] | slice:0:20; let idx = index; trackBy: trackByFilterOption">
                                        <input class="form-check-input" type="checkbox" 
                                            [value]="option.key"
                                            [checked]="isFilterValueSelected(col.colData, option.key)"
                                            (change)="toggleFilterValue(col.colData, option.key); $event.stopPropagation()"
                                            [id]="col.colData + '_idx_' + idx">
                                        <label class="form-check-label" [for]="col.colData + '_idx_' + idx">
                                            {{ option.value }}
                                        </label>
                                    </div>

                                    <div *ngIf="!filterOptions[col.colData] || filterOptions[col.colData].length === 0" 
                                        class="text-muted filter-no-options">
                                        No options available
                                    </div>

                                </div>
                            </div>

                            <div class="filter-popup-footer">
                                <button class="btn btn-sm btn-secondary" (click)="applyFilter(col, []); closeFilterPopup()">
                                    Clear
                                </button>
                                <button class="btn btn-sm btn-primary" 
                                    (click)="applyFilter(col, selectedFilterValues[col.colData])">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <!-- ========== TEXTBOX FILTER (Text input) ========== -->
                    <!-- FilterInputType="textbox" + FilterDataFetchType="text" -->
                    <ng-container *ngIf="getFilterInputType(col) === 'textbox' && getFilterDataFetchType(col) === 'text'">
                        <div class="filter-popup-wrapper" [ngStyle]="filterPopupPosition" (click)="$event.stopPropagation()">
                            <div class="filter-popup-header">
                                <span>Filter by {{ col.colName }}</span>
                                <button class="btn btn-sm btn-close" (click)="closeFilterPopup()"></button>
                            </div>

                            <div class="filter-popup-body">
                                <input type="text" class="form-control" 
                                    placeholder="Enter text..." 
                                    [(ngModel)]="filterSearchText[col.colData]"
                                    (keyup.enter)="applyFilter(col, filterSearchText[col.colData])"
                                    (keyup)="$event.stopPropagation()">
                            </div>

                            <div class="filter-popup-footer">
                                <button class="btn btn-sm btn-secondary" (click)="applyFilter(col, ''); closeFilterPopup()">
                                    Clear
                                </button>
                                <button class="btn btn-sm btn-primary" 
                                    (click)="applyFilter(col, filterSearchText[col.colData])">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <!-- ========== DATE FILTER (Condition based) ========== -->
                    <!-- FilterInputType="date" (with backward compatibility for existing date metadata) -->
                    <ng-container *ngIf="isDateFilterColumn(col)">
                        <div class="filter-popup-wrapper" [ngStyle]="filterPopupPosition" (click)="$event.stopPropagation()">
                            <div class="filter-popup-header">
                                <span>Filter by {{ col.colName }}</span>
                                <button class="btn btn-sm btn-close" (click)="closeFilterPopup()"></button>
                            </div>

                            <div class="filter-popup-body">
                                <div class="mb-1">
                                    <label class="form-label">Condition</label>
                                    <select class="form-select"
                                        [ngModel]="getDateFilterCondition(col.colData)"
                                        (ngModelChange)="onDateFilterConditionChange(col.colData, $event)">
                                        <option *ngFor="let option of dateFilterConditionOptions" [value]="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>

                                <ng-container *ngIf="getDateFilterCondition(col.colData) !== 'between'; else betweenDateInputs">
                                    <div class="mb-1">
                                        <label class="form-label">Date</label>
                                        <input type="date" class="form-control"
                                            [(ngModel)]="filterSearchText[col.colData]"
                                            (change)="$event.stopPropagation()">
                                    </div>
                                </ng-container>

                                <ng-template #betweenDateInputs>
                                    <div class="mb-1">
                                        <label class="form-label">From Date</label>
                                        <input type="date" class="form-control"
                                            [(ngModel)]="filterSearchText[col.colData + '_from']"
                                            (change)="$event.stopPropagation()">
                                    </div>

                                    <div class="mb-1">
                                        <label class="form-label">To Date</label>
                                        <input type="date" class="form-control"
                                            [(ngModel)]="filterSearchText[col.colData + '_to']"
                                            (change)="$event.stopPropagation()">
                                    </div>
                                </ng-template>

                                <div class="text-danger small" *ngIf="dateFilterValidationError[col.colData]">
                                    {{ dateFilterValidationError[col.colData] }}
                                </div>
                            </div>

                            <div class="filter-popup-footer">
                                <button class="btn btn-sm btn-secondary" 
                                    (click)="clearDateFilterInputState(col.colData); applyFilter(col, { clear: true, condition: getDateFilterCondition(col.colData) })">
                                    Clear
                                </button>
                                <button class="btn btn-sm btn-primary" 
                                    (click)="applyFilter(col, buildDateFilterPayload(col.colData))">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </ng-container>

                </ng-container>
            </ng-container>
        </ng-container>
    </div>

    <div class="table-scroll-x" *ngIf="DataLoading">
    <table class="row-border hover table table-bordered com_table" style="width: 100%;">
        <thead>
            <tr class="text-dark" style="border-left: 5px solid var(--bs-primary);">
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
                <th scope="col"><ngx-skeleton-loader count="1" width="120px" height="10px"></ngx-skeleton-loader></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
                <td style="max-width: 30px;">
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
</div>